import React, { useState } from 'react';
// components
import { TypographyNm2024 } from '../typography/styles';
// styles
import {
  ButtonStyled,
  DdStyled,
  DivStyled,
  DtStyled,
  Styles,
  TypographyNm2024Styled,
} from './styles';

export default ({
  addFAQPageSchemaItemType,
  backgroundVariant,
  branding,
  className,
  firstItemOpen,
  id,
  isFAQ,
  items,
  themeType,
  toggleCloseIcon,
  toggleOpenIcon,
  variant,
}) => {
  const styles = Styles();
  const [accordionItems, setAccordionItems] = useState(items.map((i, index) => ({
    ...i,
    isOpen: !!(firstItemOpen && index === 0),
  }))); // keeps track of open Accordion indeces

  const ToggleOpenIconComponent = toggleOpenIcon;
  const ToggleCloseIconComponent = toggleCloseIcon;
  const accordionItemTitleTypographyVariant = variant === 'primary' ? 'h4' : 'h3';
  const iconDimension = variant === 'primary' ? 15 : 30; // 30px height for FAQ +/- collapse/expand icon

  const iconProps = {
    style: styles.IconToggleStyled,
    height: iconDimension,
    width: iconDimension,
    className: 'accordion-toggle-icon',
  };

  return (
    <dl
      className={className}
      id={id}
      itemScope={isFAQ && addFAQPageSchemaItemType}
      // conditionally appending schema attributes for FAQ instances
      {...(isFAQ && addFAQPageSchemaItemType) && { itemType: 'https://schema.org/FAQPage' }}>
      {accordionItems.map((item, index) => (
        <DivStyled
          id={`container-${item.id}`}
          className='accordion-container'
          backgroundVariant={backgroundVariant}
          branding={branding}
          isFAQ={isFAQ}
          itemScope={isFAQ}
          key={`${item.title}-${index + 1}`}
          themeType={themeType}
          variant={variant}
          // conditionally appending schema attributes for FAQ instances
          {...isFAQ && {
            itemProp: 'mainEntity',
            itemType: 'https://schema.org/Question',
          }}>
          <DtStyled
            id={`dt-container-${item.id}`}
            className='accordion-dt'>
            <ButtonStyled
              aria-expanded={item.isOpen}
              className={item.isOpen && 'is-accordion-item-expanded'}
              id={`dt-button-${item.id}`}
              isFAQ={isFAQ}
              isOpen={item.isOpen}
              onClick={() => {
                setAccordionItems(accordionItems.map((i, accordionIndex) => ({
                  ...i,
                  isOpen: index === accordionIndex ? !i.isOpen : i.isOpen,
                })));
              }}
              variant={variant}>
              {item.icon && <item.icon style={styles.TitleIconStyled} />}
              <TypographyNm2024Styled
                align='left'
                className='accordion-item-title'
                component='h3'
                disableBottomPadding
                id={`dt-title-${item.id}`}
                leftPadding={!!item.icon}
                variant={accordionItemTitleTypographyVariant}
                // conditionally appending schema attributes for FAQ instances
                {...isFAQ && { itemProp: 'name' }}>
                {item.title}
              </TypographyNm2024Styled>
              {item.isOpen ? (
                <ToggleCloseIconComponent {...iconProps}/>
              ) : (
                <ToggleOpenIconComponent {...iconProps}/>
              )}
            </ButtonStyled>
          </DtStyled>
          <DdStyled
            id={`dd-container-${item.id}`}
            isFAQ={isFAQ}
            itemScope={isFAQ}
            style={{ display: item.isOpen ? 'block' : 'none' }}
            variant={variant}
            // conditionally appending schema attributes for FAQ instances
            {...isFAQ && {
              itemProp: 'acceptedAnswer',
              itemType: 'https://schema.org/Answer',
            }}>
            <TypographyNm2024
              as={item.contentAs || 'p'}
              disableBottomPadding
              // conditionally appending schema attributes for FAQ instances
              {...isFAQ && { itemProp: 'text' }}>
              {item.content}
            </TypographyNm2024>
          </DdStyled>
        </DivStyled>
      ))}
    </dl>
  );
};

